export default __webpack_public_path__ + "static/media/profile.d18cd962.svg";